function emailValidation(emailId){
	var emailAddress = $("#email").val()
	if(emailId){
		emailAddress = $("#"+emailId).val();
	}
	// E-Mail Validation
	var valid = false;
	$.ajax({
		async : false,
		dataType : "json",
		url : "/checkMail",
		data : {
			email : emailAddress
		},
		success : function(data) {
			if (data["isEmailValid"] == "1") {
				valid = true;
			} else {
				closeLoaderBox();
				alert(FmtMessage.getMessage('js.general.email'));
			}
		}
	});
	return valid;
}